import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress, Alert } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifySubscription = async () => {
      try {
        console.log('verifySubscription called');
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }
        console.log('verifySubscription token: ', token);
        const baseUrl = window.location.origin.replace('3000', '8000').replace('3500', '8500');
        const response = await fetch(`${baseUrl}/api/stripe/subscription-status`, {
          headers: {
            'x-auth-token': token
          }
        });
        const data = await response.json();
        console.log('verifySubscription response: ', data);

        if (data.hasSubscription) {
          console.log('setting hasSubscription to true');
          localStorage.setItem('hasSubscription', 'true');
        } else {
          setError('Subscription verification failed. Please contact support.');
        }
      } catch (err) {
        console.error('Error verifying subscription:', err);
        setError('An error occurred while verifying your subscription. Please contact support.');
      } finally {
        setLoading(false);
      }
    };

    verifySubscription();
  }, [navigate]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        textAlign: 'center',
      }}
    >
      {error ? (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      ) : (
        <>
          <CheckCircleOutlineIcon
            sx={{
              fontSize: 80,
              color: 'success.main',
              mb: 3,
            }}
          />
          <Typography variant="h4" component="h1" gutterBottom>
            Thank You for Subscribing!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Your premium subscription has been activated. You now have access to all premium features.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate('/')}
          >
            Return to Home
          </Button>
        </>
      )}
    </Box>
  );
}

export default SubscriptionSuccess; 